import { getMandantSettingsByTopOrga } from '../../../../util/mandant-settings-utils';
import { MandantSettings } from '../../../../util/types';
import * as React from 'react';
import { ReactNode, useRef } from 'react';
import { Tooltip } from 'primereact/tooltip';

export const topOrgaIcons = (topOrgas: string[]): { icon: string; title: string }[] => {
  return ((topOrgas || []))
    .map(getMandantSettingsByTopOrga)
    .map(
      (
        mandantSettings: MandantSettings | null
      ): {
        icon: string;
        title: string;
      } | null => (mandantSettings ? { icon: mandantSettings.icon, title: mandantSettings.topOrga } : null)
    )
    .filter((icon: { icon: string; title: string } | null): boolean => !!icon?.icon);
};

interface SelectedTemplateProps {
  label: ReactNode;
  icons?: { icon: string; title: string }[];
  tooltip?: ReactNode;
}

function SelectedTemplate(props: SelectedTemplateProps): ReactNode {
  const labelRef = useRef<HTMLDivElement>(null);
  const tooltip = props.tooltip ?? (typeof props.label === 'string' ? props.label : undefined);

  return (
    <div className={'flex flex-1 gap-1 min-w-0 overflow-hidden white-space-nowrap'}>
      {props.icons && props.icons.length > 0 && props.icons.map((icon: { icon: string; title: string }) =>
        <img src={icon.icon} alt={`${icon.title} Logo Icon`} className={'flex-shrink-0 max-w-1rem h-auto my-auto'}/>,
      )}
      <div
        ref={labelRef}
        className={'flex flex-1 min-w-0 overflow-hidden text-overflow-ellipsis white-space-nowrap'}
      >
        {props.label}
      </div>
      {tooltip && <Tooltip target={labelRef} position={'top'}>{tooltip}</Tooltip>}
    </div>
  );
}

export const renderSelectedTemplate = (
  label: ReactNode,
  icons?: { icon: string; title: string }[],
  tooltip?: ReactNode,
): ReactNode => <SelectedTemplate label={label} icons={icons} tooltip={tooltip}/>;
